






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ISharedContent } from "@/models/shared-content.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { SharedContentModule } from "@/store/modules/shared-content.store";
import { RefTypeMap } from "@/store/modules/refs.store";
import SharedContentSideCard from "@/components/partner/SharedContentSideCard.vue";
import RefsSharedContent from "@/components/utility/RefsSharedContent.vue";

@Component({
  components: {
    SharedContentSideCard,
    RefsSharedContent
  }
})
export default class SharedContentList extends Vue {
  readonly RefTypeMap = RefTypeMap;

  @Prop({ required: true })
  refId!: string;

  @Prop({ required: true })
  partnerId!: string;

  @Prop({ required: true })
  title!: string;

  sharedContent: ISharedContent[] = [];

  selectedSharedContent: ISharedContent | null = null;

  isLoading = false;

  get sharedContentFilters() {
    return [
      new PageFilterElement({
        key: "refs.refId",
        operation: PageFilterOperationEnum.EQUAL,
        value: this.refId
      })
    ];
  }

  async mounted() {
    await this.fetchSharedContent();
  }

  @Watch("refId")
  async onRefIdChange() {
    await this.fetchSharedContent();
  }

  async fetchSharedContent() {
    this.isLoading = true;
    try {
      this.sharedContent.splice(0);
      SharedContentModule.setFilters(this.sharedContentFilters);
      await SharedContentModule.fetchFirstPage({ partnerId: this.partnerId });
      const elements = SharedContentModule.filteredAndSorted;
      this.sharedContent.push(...elements.filter(e => e.refs.find(r => r.refId === this.refId)));
      SharedContentModule.setFilters([]);
      // Emit the full shared content list to parent for syncing
      this.$emit("update:sharedContent", this.sharedContent);
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  onSharedContentClick(shared: ISharedContent) {
    this.selectedSharedContent = shared;
    this.$emit("click:sharedContent", shared);
  }
}
